import { createValidationSchema } from '@utils';

export const CHANGE_USERNAME_SCHEMA = createValidationSchema({
  first_name: {
    required: true,
  },
  last_name: {
    required: true,
  },
});
